import { FirmatarioDTO } from "../firmatarioDTO";

export class RichiestaFirmaDTO {
  firmatario: FirmatarioDTO;
  idDocumento: string;
}
